import styled from "styled-components";

export const Styles = styled.div`
  * {
    @media print {
      &::-webkit-scrollbar {
        display: none !important;
      }

      scrollbar-width: none !important;

      -ms-overflow-style: none !important;

      @page {
        padding: 35px !important;
      }

      .layout-grid-item {
        page-break-inside: avoid;
        break-inside: avoid;
      }

      /* Allow tables to break if they span multiple pages, but avoid breaking individual rows */
      .layout-grid-item.is-table {
        page-break-inside: auto;
        break-inside: auto;
      }

      .table-div__row {
        page-break-inside: avoid;
        break-inside: avoid;
      }
    }
  }

  /* Hide dropdown arrows to make selects look like normal inputs */
  .ant-select-arrow {
    display: none !important;
  }
  .ant-select-selection-item {
    padding-right: 0 !important;
  }
  .ant-select-disabled .ant-select-selector {
    color: inherit !important;
  }
  .ant-select-selector::after {
    display: none !important;
  }

  /* Table Styles overriding */
  .table-div__body .table-div__cell {
    white-space: normal !important;
    overflow-wrap: anywhere;
    word-break: break-word;
    min-width: 0;
  }

  .table-div__header {
    align-items: flex-start !important;
  }

  .table-div__body .table-div__row {
    align-items: flex-start !important;
  }

  .table-div__body .table-div__row:not(:first-child) .table-div__cell {
    align-items: flex-start !important;
  }

  .table-div__body .table-div__row:first-child .table-div__cell {
    align-items: flex-start !important;
  }

  .table-div,
  .table-div__body {
    display: block !important;
    width: 100% !important;
    height: auto !important;
    overflow: visible !important;
    padding-bottom: 0px !important;
    border: none !important;
  }

  .table-div__header,
  .table-div__row {
    display: grid !important;
    width: 100% !important;
    box-sizing: border-box !important;
    margin-bottom: 0px !important;
    border: none !important;
  }

  .table-div__cell {
    /* background: transparent !important; */
    box-sizing: border-box !important;
    white-space: normal !important;
    overflow-wrap: anywhere;
    word-break: break-word;
    min-width: 0;
    padding: 4px 8px !important;
    border: none !important;
  }
`;
